import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" };
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" };
const _hoisted_3 = { class: "d-sm-flex align-items-center" };
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25" };
const _hoisted_5 = {
    key: 0,
    class: "text-center py-5"
};
const _hoisted_6 = {
    key: 1,
    class: "text-center py-5"
};
const _hoisted_7 = {
    key: 2,
    class: "table-responsive"
};
const _hoisted_8 = { class: "table text-nowrap align-middle mb-0" };
const _hoisted_9 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_10 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_11 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_12 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_13 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end"
};
const _hoisted_14 = { class: "fw-semibold text-black" };
const _hoisted_15 = { class: "text-black" };
const _hoisted_16 = { class: "d-flex gap-1 flex-wrap" };
const _hoisted_17 = ["title"];
const _hoisted_18 = ["onUpdate:modelValue", "onBlur", "disabled"];
const _hoisted_19 = { class: "text-end" };
const _hoisted_20 = { class: "dropdown" };
const _hoisted_21 = ["id"];
const _hoisted_22 = ["aria-labelledby"];
const _hoisted_23 = ["onClick"];
const _hoisted_24 = ["onClick"];
const _hoisted_25 = ["onClick"];
const _hoisted_26 = {
    class: "modal fade",
    id: "supplementTypeModal",
    tabindex: "-1",
    "aria-labelledby": "supplementTypeModalLabel",
    "aria-hidden": "true"
};
const _hoisted_27 = { class: "modal-dialog modal-dialog-centered" };
const _hoisted_28 = { class: "modal-content" };
const _hoisted_29 = { class: "modal-header" };
const _hoisted_30 = {
    class: "modal-title",
    id: "supplementTypeModalLabel"
};
const _hoisted_31 = { class: "modal-body" };
const _hoisted_32 = { class: "mb-3" };
const _hoisted_33 = {
    for: "typeCode",
    class: "form-label"
};
const _hoisted_34 = ["disabled"];
const _hoisted_35 = { class: "text-muted" };
const _hoisted_36 = { class: "mb-3" };
const _hoisted_37 = {
    for: "typePosition",
    class: "form-label"
};
const _hoisted_38 = { class: "text-muted" };
const _hoisted_39 = { class: "mb-3" };
const _hoisted_40 = { class: "form-label fw-semibold" };
const _hoisted_41 = { class: "row g-2" };
const _hoisted_42 = { class: "col-md-6" };
const _hoisted_43 = { class: "col-md-6" };
const _hoisted_44 = { class: "col-md-6" };
const _hoisted_45 = { class: "col-md-6" };
const _hoisted_46 = { class: "d-flex justify-content-end gap-2" };
const _hoisted_47 = {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal"
};
const _hoisted_48 = ["disabled"];
const _hoisted_49 = { key: 0 };
const _hoisted_50 = { key: 1 };
const _hoisted_51 = {
    class: "modal fade",
    id: "translationsModal",
    tabindex: "-1",
    "aria-labelledby": "translationsModalLabel",
    "aria-hidden": "true"
};
const _hoisted_52 = { class: "modal-dialog modal-dialog-centered" };
const _hoisted_53 = { class: "modal-content" };
const _hoisted_54 = { class: "modal-header" };
const _hoisted_55 = {
    class: "modal-title",
    id: "translationsModalLabel"
};
const _hoisted_56 = { class: "modal-body" };
const _hoisted_57 = { class: "row g-3" };
const _hoisted_58 = ["for"];
const _hoisted_59 = { class: "input-group" };
const _hoisted_60 = ["id", "onUpdate:modelValue", "onBlur", "disabled"];
const _hoisted_61 = ["onClick", "disabled"];
const _hoisted_62 = { key: 0 };
const _hoisted_63 = { key: 1 };
const _hoisted_64 = { class: "modal-footer" };
const _hoisted_65 = {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal"
};
const _hoisted_66 = {
    class: "modal fade",
    id: "deleteConfirmModal",
    tabindex: "-1",
    "aria-labelledby": "deleteConfirmModalLabel",
    "aria-hidden": "true"
};
const _hoisted_67 = { class: "modal-dialog modal-dialog-centered" };
const _hoisted_68 = { class: "modal-content" };
const _hoisted_69 = { class: "modal-header" };
const _hoisted_70 = {
    class: "modal-title",
    id: "deleteConfirmModalLabel"
};
const _hoisted_71 = { class: "modal-body" };
const _hoisted_72 = ["innerHTML"];
const _hoisted_73 = { class: "modal-footer" };
const _hoisted_74 = {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal"
};
const _hoisted_75 = ["disabled"];
const _hoisted_76 = { key: 0 };
const _hoisted_77 = { key: 1 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    const _component_EmptyTable = _resolveComponent("EmptyTable");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        (...args) => (_ctx.openAddModal && _ctx.openAddModal(...args))),
                    class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                    type: "button"
                }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('supplement.addSupplementType')) + " ", 1),
                    _cache[9] || (_cache[9] = _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1))
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_4, [
            (_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_LoaderComponent)
                ]))
                : (_ctx.supplementTypes.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_EmptyTable, {
                            message: _ctx.$t('supplement.noSupplementTypesAvailable')
                        }, null, 8, ["message"])
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("table", _hoisted_8, [
                            _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('supplement.code')), 1),
                                    _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('supplement.label')) + " (" + _toDisplayString(_ctx.currentLanguage.toUpperCase()) + ") ", 1),
                                    _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('supplement.translations')), 1),
                                    _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('supplement.position')), 1),
                                    _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('common.actions')), 1)
                                ])
                            ]),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedSupplementTypes, (type) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        key: type.id
                                    }, [
                                        _createElementVNode("td", _hoisted_14, _toDisplayString(type.code), 1),
                                        _createElementVNode("td", _hoisted_15, _toDisplayString(type.label), 1),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("div", _hoisted_16, [
                                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['fr', 'en', 'de', 'it'], (locale) => {
                                                    return _createElementVNode("span", {
                                                        key: locale,
                                                        class: _normalizeClass(["badge", {
                                                                'bg-success': type.translations && type.translations[locale] && type.translations[locale].trim() !== '',
                                                                'bg-warning': !type.translations || !type.translations[locale] || type.translations[locale].trim() === ''
                                                            }]),
                                                        style: { "font-size": "0.75rem" },
                                                        title: (type.translations && type.translations[locale]) ? String(type.translations[locale]) : `${locale.toUpperCase()}: ${_ctx.$t('supplement.notDefined')}`
                                                    }, _toDisplayString(locale.toUpperCase()), 11, _hoisted_17);
                                                }), 64))
                                            ])
                                        ]),
                                        _createElementVNode("td", null, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "number",
                                                class: "form-control shadow-none rounded-0 text-black",
                                                "onUpdate:modelValue": ($event) => ((type.position) = $event),
                                                min: "1",
                                                style: { "width": "100px" },
                                                onBlur: ($event) => (_ctx.updatePosition(type)),
                                                disabled: _ctx.isUpdatingPosition
                                            }, null, 40, _hoisted_18), [
                                                [
                                                    _vModelText,
                                                    type.position,
                                                    void 0,
                                                    { number: true }
                                                ]
                                            ])
                                        ]),
                                        _createElementVNode("td", _hoisted_19, [
                                            _createElementVNode("div", _hoisted_20, [
                                                _createElementVNode("button", {
                                                    class: "dot-btn lh-1 position-relative top-3 bg-transparent border-0 shadow-none p-0 transition d-inline-block",
                                                    type: "button",
                                                    id: `dropdownMenuButton-${type.id}`,
                                                    "data-bs-toggle": "dropdown",
                                                    "aria-expanded": "false"
                                                }, [...(_cache[10] || (_cache[10] = [
                                                        _createElementVNode("i", { class: "flaticon-dots" }, null, -1)
                                                    ]))], 8, _hoisted_21),
                                                _createElementVNode("ul", {
                                                    class: "dropdown-menu",
                                                    "aria-labelledby": `dropdownMenuButton-${type.id}`
                                                }, [
                                                    _createElementVNode("li", null, [
                                                        _createElementVNode("a", {
                                                            class: "dropdown-item",
                                                            href: "#",
                                                            onClick: _withModifiers(($event) => (_ctx.openEditModal(type)), ["prevent"])
                                                        }, [
                                                            _cache[11] || (_cache[11] = _createElementVNode("i", { class: "flaticon-edit me-2" }, null, -1)),
                                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('common.edit')), 1)
                                                        ], 8, _hoisted_23)
                                                    ]),
                                                    _createElementVNode("li", null, [
                                                        _createElementVNode("a", {
                                                            class: "dropdown-item",
                                                            href: "#",
                                                            onClick: _withModifiers(($event) => (_ctx.openTranslationsModal(type)), ["prevent"])
                                                        }, [
                                                            _cache[12] || (_cache[12] = _createElementVNode("i", { class: "fas fa-language me-2" }, null, -1)),
                                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('supplement.manageTranslations')), 1)
                                                        ], 8, _hoisted_24)
                                                    ]),
                                                    _cache[14] || (_cache[14] = _createElementVNode("li", null, [
                                                        _createElementVNode("hr", { class: "dropdown-divider" })
                                                    ], -1)),
                                                    _createElementVNode("li", null, [
                                                        _createElementVNode("a", {
                                                            class: "dropdown-item text-danger",
                                                            href: "#",
                                                            onClick: _withModifiers(($event) => (_ctx.confirmDelete(type)), ["prevent"])
                                                        }, [
                                                            _cache[13] || (_cache[13] = _createElementVNode("i", { class: "flaticon-trash me-2" }, null, -1)),
                                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('common.delete')), 1)
                                                        ], 8, _hoisted_25)
                                                    ])
                                                ], 8, _hoisted_22)
                                            ])
                                        ])
                                    ]));
                                }), 128))
                            ])
                        ])
                    ]))
        ]),
        _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("h5", _hoisted_30, _toDisplayString(_ctx.isEditing
                            ? _ctx.$t('supplement.editSupplementType')
                            : _ctx.$t('supplement.addSupplementType')), 1),
                        _cache[15] || (_cache[15] = _createElementVNode("button", {
                            type: "button",
                            class: "btn-close",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        }, null, -1))
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("form", {
                            onSubmit: _cache[7] || (_cache[7] = _withModifiers(
                            //@ts-ignore
                            (...args) => (_ctx.saveSupplementType && _ctx.saveSupplementType(...args)), ["prevent"]))
                        }, [
                            _createElementVNode("div", _hoisted_32, [
                                _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t('supplement.code')) + " * ", 1),
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    id: "typeCode",
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.formData.type) = $event)),
                                    required: "",
                                    disabled: _ctx.isEditing
                                }, null, 8, _hoisted_34), [
                                    [_vModelText, _ctx.formData.type]
                                ]),
                                _createElementVNode("small", _hoisted_35, _toDisplayString(_ctx.$t('supplement.codeHelp')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_36, [
                                _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t('supplement.position')), 1),
                                _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    class: "form-control",
                                    id: "typePosition",
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.formData.position) = $event)),
                                    min: "1"
                                }, null, 512), [
                                    [
                                        _vModelText,
                                        _ctx.formData.position,
                                        void 0,
                                        { number: true }
                                    ]
                                ]),
                                _createElementVNode("small", _hoisted_38, _toDisplayString(_ctx.$t('supplement.positionHelp')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_39, [
                                _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.$t('supplement.translations')), 1),
                                _createElementVNode("div", _hoisted_41, [
                                    _createElementVNode("div", _hoisted_42, [
                                        _cache[16] || (_cache[16] = _createElementVNode("label", {
                                            for: "translationFr",
                                            class: "form-label small"
                                        }, " Français ", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            id: "translationFr",
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.formData.translations.fr) = $event))
                                        }, null, 512), [
                                            [_vModelText, _ctx.formData.translations.fr]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_43, [
                                        _cache[17] || (_cache[17] = _createElementVNode("label", {
                                            for: "translationEn",
                                            class: "form-label small"
                                        }, " English ", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            id: "translationEn",
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.formData.translations.en) = $event))
                                        }, null, 512), [
                                            [_vModelText, _ctx.formData.translations.en]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_44, [
                                        _cache[18] || (_cache[18] = _createElementVNode("label", {
                                            for: "translationDe",
                                            class: "form-label small"
                                        }, " Deutsch ", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            id: "translationDe",
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.formData.translations.de) = $event))
                                        }, null, 512), [
                                            [_vModelText, _ctx.formData.translations.de]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_45, [
                                        _cache[19] || (_cache[19] = _createElementVNode("label", {
                                            for: "translationIt",
                                            class: "form-label small"
                                        }, " Italiano ", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            id: "translationIt",
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.formData.translations.it) = $event))
                                        }, null, 512), [
                                            [_vModelText, _ctx.formData.translations.it]
                                        ])
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_46, [
                                _createElementVNode("button", _hoisted_47, _toDisplayString(_ctx.$t('common.cancel')), 1),
                                _createElementVNode("button", {
                                    type: "submit",
                                    class: "btn btn-success",
                                    disabled: _ctx.isSaving
                                }, [
                                    (_ctx.isSaving)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(_ctx.$t('common.saving')) + "...", 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(_ctx.$t('common.save')), 1))
                                ], 8, _hoisted_48)
                            ])
                        ], 32)
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("h5", _hoisted_55, _toDisplayString(_ctx.$t('supplement.manageTranslations')) + " - " + _toDisplayString(_ctx.typeForTranslations?.code), 1),
                        _cache[20] || (_cache[20] = _createElementVNode("button", {
                            type: "button",
                            class: "btn-close",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        }, null, -1))
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("div", _hoisted_57, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableLocales, (locale) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    class: "col-md-6",
                                    key: locale.code
                                }, [
                                    _createElementVNode("label", {
                                        for: `translation-${locale.code}`,
                                        class: "form-label fw-semibold"
                                    }, _toDisplayString(locale.name), 9, _hoisted_58),
                                    _createElementVNode("div", _hoisted_59, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            id: `translation-${locale.code}`,
                                            "onUpdate:modelValue": ($event) => ((_ctx.translationFormData[locale.code]) = $event),
                                            onBlur: ($event) => (_ctx.updateTranslation(locale.code)),
                                            disabled: _ctx.isUpdatingTranslation === locale.code
                                        }, null, 40, _hoisted_60), [
                                            [_vModelText, _ctx.translationFormData[locale.code]]
                                        ]),
                                        (_ctx.translationFormData[locale.code])
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                class: "btn btn-outline-success",
                                                type: "button",
                                                onClick: ($event) => (_ctx.updateTranslation(locale.code)),
                                                disabled: _ctx.isUpdatingTranslation === locale.code
                                            }, [
                                                (_ctx.isUpdatingTranslation === locale.code)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_62, [...(_cache[21] || (_cache[21] = [
                                                            _createElementVNode("i", { class: "fas fa-spinner fa-spin" }, null, -1)
                                                        ]))]))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_63, [...(_cache[22] || (_cache[22] = [
                                                            _createElementVNode("i", { class: "fas fa-check" }, null, -1)
                                                        ]))]))
                                            ], 8, _hoisted_61))
                                            : _createCommentVNode("", true)
                                    ])
                                ]));
                            }), 128))
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("button", _hoisted_65, _toDisplayString(_ctx.$t('common.close')), 1)
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_66, [
            _createElementVNode("div", _hoisted_67, [
                _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("h5", _hoisted_70, _toDisplayString(_ctx.$t('supplement.deleteTypeConfirmation')), 1),
                        _cache[23] || (_cache[23] = _createElementVNode("button", {
                            type: "button",
                            class: "btn-close",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        }, null, -1))
                    ]),
                    _createElementVNode("div", _hoisted_71, [
                        _createElementVNode("p", {
                            innerHTML: _ctx.$t('supplement.deleteTypeConfirmationText')
                        }, null, 8, _hoisted_72)
                    ]),
                    _createElementVNode("div", _hoisted_73, [
                        _createElementVNode("button", _hoisted_74, _toDisplayString(_ctx.$t('common.cancel')), 1),
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-danger",
                            onClick: _cache[8] || (_cache[8] =
                                //@ts-ignore
                                (...args) => (_ctx.deleteSupplementType && _ctx.deleteSupplementType(...args))),
                            disabled: _ctx.isDeleting
                        }, [
                            (_ctx.isDeleting)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_76, _toDisplayString(_ctx.$t('common.deleting')) + "...", 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_77, _toDisplayString(_ctx.$t('common.delete')), 1))
                        ], 8, _hoisted_75)
                    ])
                ])
            ])
        ])
    ]));
}
